import regeneratorRuntime from 'regenerator-runtime';
// Always include this first
// https://stackoverflow.com/questions/40897966/objects-are-not-valid-as-a-react-child-in-internet-explorer-11-for-react-15-4-1
import '@babel/polyfill';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import 'whatwg-fetch';
import 'smartbanner.js/dist/smartbanner.min';
import 'smartbanner.js/dist/smartbanner.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
// eslint-disable-next-line import/no-unresolved
import 'jquery?noModules';
import moment from 'moment';
import 'moment-range';
import { monkey } from 'moment-round';
import '../3rdParty/sdks';

import { DEBUG, ENV } from '../config';

window.regeneratorRuntime = regeneratorRuntime;

/**
 * Primary libraries needed for the app and installed from npm.
 */

// React
window.React = React;
window.ReactDOM = ReactDOM;

// Moment
window.moment = moment;
monkey(window.moment);

/**
 * Debugging
 */
if (DEBUG && ENV !== 'production') {
  // eslint-disable-next-line global-require
  const { whyDidYouUpdate } = require('why-did-you-update');
  whyDidYouUpdate(React, {
    exclude: [
      /SSErrorBoundary/,
      /StateLink/,
      /Carousel/,
      /ProDailyNotificationContainer/,
    ],
  });
}
